/**
 * ArtifactSalvage - rekompensata za zniszczone Artefakty (lustro offline).
 *
 * Odpowiednik `backend/services/ArtifactSalvage.js`: Legendarny Artefakt daje 4 Punkty
 * Chwały, zwykły połowę swojej ceny w Złocie (w GÓRĘ, do puli tury). Artefakt zdjęty ze
 * slotu jako Ofiara z karty nie daje nic (patrz `destroyWithoutSalvage`).
 *
 * Rozliczanie kursorowe (`player.artifactSalvageCursor`) - dokładnie jak na serwerze,
 * dzięki czemu ~20 miejsc dopisujących do `player.destroyed` w offline'owym CardEffects
 * nie wymaga zmian. Punkt rozliczenia: `serializeGame` w workers/gameWorker.js.
 */

import ResourceManager from './ResourceManager.js';
import { getArtifactSalvageReward, LEGENDARY_SALVAGE_FAME } from '../cardHelpers.js';

// Statyczne importy JSON - te same, z których korzysta offline'owy GameEngine.
import cardsBgsPl from '../../public/assets/card_bgs/cards_bgs_pl.json';

let artifactIndex = null;

function getIndex() {
  if (artifactIndex) return artifactIndex;
  artifactIndex = new Map();
  // Nagroda zależy tylko od `subtype` i `cost`, a te są identyczne we wszystkich
  // wersjach językowych - wystarczy jedna talia (PL) jako źródło.
  for (const group of Object.values(cardsBgsPl.cards || {})) {
    if (!Array.isArray(group)) continue;
    for (const card of group) {
      const reward = getArtifactSalvageReward(card);
      if (reward && card.id) artifactIndex.set(card.id, reward);
    }
  }
  return artifactIndex;
}

/**
 * Dopłać za Artefakty dopisane do `player.destroyed` od ostatniego rozliczenia.
 * Idempotentne.
 * @returns {null|{fame: Number, gold: Number, items: Array}}
 */
export function settle(player) {
  if (!player) return null;
  const destroyed = player.destroyed || [];

  if (player.artifactSalvageCursor == null) {
    player.artifactSalvageCursor = destroyed.length;
    return null;
  }
  if (player.artifactSalvageCursor >= destroyed.length) {
    player.artifactSalvageCursor = destroyed.length;
    return null;
  }

  const index = getIndex();
  const items = [];
  let fame = 0;
  let gold = 0;

  for (let i = player.artifactSalvageCursor; i < destroyed.length; i++) {
    const reward = index.get(destroyed[i]);
    if (!reward) continue;
    fame += reward.fame;
    gold += reward.gold;
    items.push({ cardId: destroyed[i], ...reward });
  }

  player.artifactSalvageCursor = destroyed.length;
  if (items.length === 0) return null;

  if (fame > 0) player.fame = (player.fame || 0) + fame;
  if (gold > 0) ResourceManager.addToPool(player, { gold });
  return { fame, gold, items };
}

/** Rozlicz wszystkich graczy naraz (wołane przy serializacji stanu w workerze). */
export function settleAll(game) {
  for (const player of game?.players || []) settle(player);
}

/** Zniszcz kartę bez rekompensaty - Ofiara z karty albo koszt Kontraktu. */
export function destroyWithoutSalvage(player, cardId) {
  if (!player) return;
  if (!Array.isArray(player.destroyed)) player.destroyed = [];
  settle(player);
  player.destroyed.push(cardId);
  player.artifactSalvageCursor = player.destroyed.length;
}

export { LEGENDARY_SALVAGE_FAME };

const ArtifactSalvage = { settle, settleAll, destroyWithoutSalvage, LEGENDARY_SALVAGE_FAME };
export default ArtifactSalvage;
